const calculateOpacity = (opacity) => 1 - opacity

export const DraggableBackground = ({
  backgroundX,
  backgroundY,
  pageLayout,
  preprinted,
  pageTwo,
  backgroundImageUrl,
}) => {
  // Calculate the inverse of the white overlay opacity
  const backgroundImageOpacity = calculateOpacity(
    pageLayout?.background_opacity || 0,
  )

  const hasExplicitOpacity =
    pageLayout?.background_opacity !== undefined &&
    pageLayout?.background_opacity !== null

  let finalOpacity = 1
  if (hasExplicitOpacity) {
    finalOpacity = backgroundImageOpacity
  } else if (pageTwo) {
    finalOpacity = 0.3
  }

  let finalBackgroundImage = ''
  if (!pageLayout?.hide_background && !preprinted) {
    finalBackgroundImage = `url(${backgroundImageUrl})`
  }

  let finalBackgroundSize = 'cover'
  if (pageLayout?.background_fill) {
    finalBackgroundSize = pageLayout.background_fill
  }

  return {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: finalOpacity,
    backgroundPosition: `${backgroundX}px ${backgroundY}px`,
    backgroundRepeat: 'no-repeat',
    backgroundImage: finalBackgroundImage,
    backgroundSize: finalBackgroundSize,
    pointerEvents: 'none',
    touchAction: 'none',
  }
}
